import { render, staticRenderFns } from "./CombinenowComponent.vue?vue&type=template&id=90385010&scoped=true"
import script from "./CombinenowComponent.vue?vue&type=script&lang=js"
export * from "./CombinenowComponent.vue?vue&type=script&lang=js"
import style0 from "./CombinenowComponent.vue?vue&type=style&index=0&id=90385010&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90385010",
  null
  
)

export default component.exports